(() => {
  if (customElements.get('predictive-search')) return;
  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('[data-predictive-search-results], #predictive-search');
      if (!this.input || !this.predictiveSearchResults) return;
      this.listeners?.abort();
      this.listeners = new AbortController();
      this.input.addEventListener('input', () => {
        // Invalidate immediately, before the debounce. A previous query may finish
        // during those 300ms, or after Escape, focus-out or a section replacement.
        this.dismiss();
        this.debounceTimer = setTimeout(() => this.onChange(), 300);
      }, { signal: this.listeners.signal });
    }

    disconnectedCallback() {
      this.listeners?.abort();
      this.dismiss();
    }

    dismiss() {
      clearTimeout(this.debounceTimer);
      this.request?.abort();
      this.request = null;
      this.close();
    }

    onChange() {
      const searchTerm = this.input.value.trim();
      if (searchTerm && this.isConnected) this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
      this.request?.abort();
      const request = new AbortController();
      this.request = request;
      fetch(`${window.theme.routes.predictiveSearch}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`, { signal: request.signal })
        .then(response => {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then(text => {
          if (this.request !== request || !this.isConnected || this.input.value.trim() !== searchTerm) return;
          const results = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search');
          if (!results) { this.close(); return; }
          this.predictiveSearchResults.innerHTML = results.innerHTML;
          this.open();
        })
        .catch(error => {
          if (error.name !== 'AbortError' && this.request === request) this.close();
          // Suggestions may fail; the ordinary search form remains usable.
        });
    }

    open() {
      const header = this.closest('[data-header-search]');
      if (header && (!header.contains(document.activeElement) || (header.classList.contains('is-collapsible') && !header.classList.contains('is-open')))) return;
      this.predictiveSearchResults.style.display = 'block';
    }

    close() {
      if (this.predictiveSearchResults) this.predictiveSearchResults.style.display = 'none';
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
})();
